import { h } from "../../core/dom.js";

const DEFAULT_TIMEOUT = 2600;
const FADE_MS = 400;

export function createToaster(root = document.body) {
  const container = h("div", { class: "toasts", role: "status", "aria-live": "polite" });
  root.append(container);
  let timers = [];
  return (message, kind = "info", timeout = DEFAULT_TIMEOUT) => {
    timers.forEach(clearTimeout);
    timers = [];
    const toast = h("div", { class: `toast toast-${kind}` }, message);
    container.replaceChildren(toast);
    timers.push(setTimeout(() => toast.classList.add("leaving"), timeout));
    timers.push(setTimeout(() => toast.remove(), timeout + FADE_MS));
    return toast;
  };
}
